import StandardComparison from "../components/PeerGroup/StandardComparison";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All } from "../interfaces";
import { updateUi } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateComparisonType: (comparisonType: string) => {
      dispatch(updateUi("comparisonType", comparisonType));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StandardComparison);
